<template>
  <div class="page-wrapper rep-dashboard-wrapper enrollprime-dashboard">
    <div class="container-fluid">
      <div class="row align-items-end">
        <div class="col-12 sectionTitle manage-business-title mb-4">
            <h5 class="title-section mb-2 mb-md-0">Manage Business</h5>

            <div class="d-flex align-items-center location-filter gap-2">
              <label for="locationFilter" >
                View by Location:
              </label>
              <multiselect
                id="locationFilter"
                v-model="selectedLocation"
                :options="locationOptions"
                :searchable="false"
                :show-labels="false"
                placeholder="All Locations"
                track-by="value"
                class="form-select-custom"
                :allow-empty="false"
                :close-on-select="true"
                :max-height="250"
                label="label"
              />
              <!-- <select
                id="locationFilter"
                class="form-select"
                
              >
                <option selected>All Locations</option>
                <option>WPB SALES</option>
                <option>HMS SALES</option>
                <option>PLANT SALES</option>
                <option>REMOTE SALES</option>
                <option>CUSTO SALES</option>
              </select> -->
            </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-4">
          <h5 class="title-section">Manage Business</h5>
          <div class="overallInfo-blockWrapper rep-dash p-3 noHeight">
            <div class="manage-btn ">
              <button @click="routeToLink('/view-members')">Members</button>
              <button
                v-if="isDownlineHasAccess"
                @click="routeToLink('/view-downline-reps')"
                class="mb-0"
              >
                Downline Reps
              </button>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-4">
        <div class="overallInfo-blockWrapper p-2 no-margin-bottom" style="padding-bottom: 0; margin-bottom: 0;">
          <div class="d-flex justify-content-between align-items-center">
            <!-- Total Active -->
            <div class="dataBlock-active">
              <div class="iconBlock">
                <i class="fas fa-user-check"></i>
              </div>
              <div>
                <span>Total Active</span>
                <h3>{{ memberData.total_active ?? 0 }}</h3>
              </div>
            </div>

            <!-- Total Termed -->
            <div class="dataBlock-termed">
              <div class="iconBlock">
                <i class="fas fa-user-slash"></i>
              </div>
              <div>
                <span>Total Termed</span>
                <h3>{{ memberData.total_termed ?? 0 }}</h3>
              </div>
            </div>

            <!-- Total Withdrawn -->
            <div class="dataBlock-withdrawn">
              <div class="iconBlock">
                <i class="fas fa-user-times"></i>
              </div>
              <div>
                <span>Total Withdrawn</span>
                <h3>{{ memberData.total_withdraw ?? 0 }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-4">
      <div class="overallInfo-blockWrapper p-2 no-margin-bottom" style="padding-bottom: 0; margin-bottom: 0;">
        <div class="d-flex justify-content-between align-items-center ">

          <!-- Average Age -->
          <div class="dataBlock-average-age">
            <div class="iconBlock">
              <i class="fas fa-id-card"></i>
            </div>
            <div>
              <span>Avg. Age</span>
              <h3>{{ memberData.average_age ?? 0 }}</h3>
            </div>
          </div>

          <!-- Average Premium -->
          <div class="dataBlock-average-premium">
            <div class="iconBlock">
              <i class="fas fa-dollar-sign"></i>
            </div>
            <div>
              <span>Avg. Premium</span>
              <h3>{{ memberData.average_premium ?? 0 }}</h3>
            </div>
          </div>

          <!-- Average Lifespan -->
          <div class="dataBlock-average-lifespan">
            <div class="iconBlock">
              <i class="fas fa-heartbeat"></i>
            </div>
            <div>
              <span>Avg. Lifespan</span>
              <h3>{{ memberData.average_lifespan ?? 0 }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

        <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-6 vue-custom-scrollbar">
              <pending-items :title="false"  style="height: 140px;"/>
        </div>
      </div>
      <!-- <div class="row">
        <div
          class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 vue-custom-scrollbar"
        >
          <pending-items />
        </div>
      </div> -->
      <div class="row">
        <div class="col-xl-12 mb-3">
          <div class="sectionTitle">
            <h5 class="title-section">Overall Enrollment Analytics</h5>
            <div class="d-flex granFilter align-items-center mb-3">
              <label for="">Filter Via:</label>
              <select
                v-model="selectedFilter"
                @change="updateChart"
                class="form-select"
              >
                <option>Yearly</option>
                <option>Weekly</option>
                <option>Monthly</option>
                <option>Last Week</option>
                <option>Last 30 Days</option>
              </select>
            </div>
          </div>
          <div class="overallInfo-blockWrapper noHeight p-3 ps-2 pb-2">
            <apexchart
              type="area"
              height="350"
              :options="chartOptions"
              :series="series"
            />
          </div>
        </div>
        <!-- <MemberStatusGraph />-->
      </div>
      <div class="row">
        <state-enroll-table-data v-if="memberData.top_states" :memberDataByStates="memberData.top_states" />
        <tier-enroll-table-data :memberDataByTier="memberData.by_tier" />
        <termination-withdrawn :sorted-list="topReasons" />
      </div>
    </div>
  </div>
</template>

<script>
import Helper from "@/resource/Helper";
import Api from "@/resource/Api";
import { restrictedReps } from "@/utils/constant";
import VueApexCharts from "vue-apexcharts";
import StateEnrollTableData from "./partials/StateEnrollTableData.vue";
import TierEnrollTableData from "./partials/TierEnrollTableData.vue";
import TerminationWithdrawn from "./partials/TerminationWithdrawn.vue";
// import MemberStatusGraph from "./partials/MemberStatusGraph.vue";

const calculatePercentage = (count, total) => (
  (count / total) * 100
).toFixed(2);

const extractNameCount = (array) => {
  return array.map((item) => ({
    act: item.act,
    total: item.total,
  }));
};

export default {
  name: "EnrollPrimeDashboard",
  components: {
    apexchart: VueApexCharts,
    StateEnrollTableData,
    TierEnrollTableData,
    TerminationWithdrawn,
    // MemberStatusGraph,
  },
  data: () => ({
    isDownlineHasAccess: false,
    enrollableData: [],
    selectedFilter: "Last 30 Days",
    memberData: [],
    locationOptions: [
      { label: 'All Locations', value: null },
      { label: 'WPB SALES', value: '103985' },
      { label: 'HMS SALES', value: '103981' },
      { label: 'PLANT SALES', value: '103979' },
      { label: 'REMOTE SALES', value: '103982' },
      { label: 'CUSTO SALES', value: '103978' },
    ],
    selectedLocation: { label: 'All Locations', value: null },
    // Chart Data
    series: [
      {
        name: "Active",
        data: [],
      },
      {
        name: "Termed",
        data: [],
      },
      {
        name: "Withdrawn",
        data: [],
      },
    ],
    // Chart Options
    // chartOptions: {
    //   chart: {
    //     id: "vue-line-chart",
    //     type: "line",
    //     zoom: { enabled: false },
    //     toolbar: { show: false },
    //   },
    //   xaxis: {
    //     categories: [],
    //   },
    //   tooltip: {
    //       enabled: true,
    //       shared: true,
    //       intersect: false,
    //       marker: {
    //         show: true,
    //         fillColors:  ['#02BC77', '#F29423', '#EA584E'], 
    //       }
    //     },
    //   stroke: {
    //     curve: "straight",
    //     width: 3,
    //     colors: ['#02BC77', '#F29423', '#EA584E'], 
    //   },
    //   fill: {
    //     type: "solid",
    //     opacity: 1, 
    //   },
    //   legend: {
    //     markers: {
    //       fillColors:   ['#02BC77', '#F29423', '#EA584E'], 
    //     },
    //   },
    //   dataLabels: {
    //     enabled: false,
    //   },
    // },
     chartOptions: {
            chart: {
              id: "vue-line-chart",
              height: 350,
              type: 'area',
              toolbar: {
                  show: true,
                   export: {
                    csv: {
                      filename: 'overall-enrollment-analytics',
                    },
                    svg: {
                      filename: 'overall-enrollment-analytics',
                    },
                    png: {
                      filename: 'overall-enrollment-analytics',
                    }
                  },
                  tools: {
                    pan: false, 
                  }
                },
                zoom: { enabled: true },
            },
            colors: ['#02BC77', '#F29423', '#EA584E'],
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth',
              width: '3'
            },
            xaxis: {
              type: 'category',
              categories: []
            },   
            fill: {
                type: "gradient",
                gradient: {
                shadeIntensity: 1,
                opacityFrom: 0,
                opacityTo: 0,
                stops: [0, 90, 100]
                }
            },
            legend: {
              markers: {
                fillColors:   ['#02BC77', '#F29423', '#EA584E'], 
              },
            },      
    },   
    topReasons: [],
  }),
  created() {
    Helper.dashboardGetters();
    this.$store.dispatch("getRepInfo");
    this.getRistrictDownlineFlag();
    this.getEnrollableData();
  },
  computed: {
    repInfo() {
      return this.$store.getters.rep;
    },
    repCode() {
      return this.$store.getters.repId;
    },
    displayItems() {
      if (restrictedReps.includes(this.repCode)) {
        return false;
      }
      return true;
    },
  },  
  methods: {
    openLinkInNewTab(url) {
      window.open(url, "_blank");
    },
    updateChart() {
      let labels = [];
      let enrollData = [];
      let termedData = [];
      let withdrawnData = [];

      if (this.selectedFilter === "Yearly") {
        //labels = Object.keys(this.memberData.yearly_enrollment);
        labels = [...new Set([...labels, ...Object.keys(this.memberData.yearly_termed || {}), ...Object.keys(this.memberData.yearly_withdrawn || this.memberData.yearly_enrollment || {})])];
        enrollData = Object.values(this.memberData.yearly_enrollment);
        termedData = Object.values(this.memberData.yearly_termed || {});
        withdrawnData = Object.values(this.memberData.yearly_withdrawn || {});
      } else if (this.selectedFilter === "Monthly") {
        // labels = Object.keys(this.memberData.monthly_enrollment).map(date =>
        //   new Date(date).toLocaleDateString("en-US", { month: "short", day: "numeric" })
        // );
        labels = [...new Set([...labels, ...Object.keys(this.memberData.monthly_termed || {}), ...Object.keys(this.memberData.monthly_withdrawn || {}), ...Object.keys(this.memberData.monthly_enrollment || {})])];
        labels = labels.map(date => new Date(date).toLocaleDateString("en-US", { month: "short", day: "numeric" }));
        enrollData = Object.values(this.memberData.monthly_enrollment);
        termedData = Object.values(this.memberData.monthly_termed || {});
        withdrawnData = Object.values(this.memberData.monthly_withdrawn || {});
      }
      else if (this.selectedFilter === "Last 30 Days") {
        labels = [...new Set([...labels, ...Object.keys(this.memberData.last_month_termed || {}), ...Object.keys(this.memberData.last_month_withdrawn || {}), ...Object.keys(this.memberData.last_month_enrollment || {})])];
        labels = labels.map(date => new Date(date).toLocaleDateString("en-US", { month: "short", day: "numeric" }));
        enrollData = Object.values(this.memberData.last_month_enrollment);
        termedData = Object.values(this.memberData.last_month_termed || {});
        withdrawnData = Object.values(this.memberData.last_month_withdrawn || {});
      }
      else if (this.selectedFilter === "Last Week") {
        // labels = Object.keys(this.memberData.weekly_enrollment.last_week);
        labels = [...new Set([...labels, ...Object.keys(this.memberData.weekly_termed.last_week || {}), ...Object.keys(this.memberData.weekly_withdrawn.last_week || this.memberData.weekly_enrollment.last_week || {})])];
        enrollData = Object.values(this.memberData.weekly_enrollment.last_week);
        termedData = Object.values((this.memberData.weekly_termed && this.memberData.weekly_termed.last_week) || {});
        withdrawnData = Object.values((this.memberData.weekly_withdrawn && this.memberData.weekly_withdrawn.last_week) || {});
      } else if (this.selectedFilter === "Weekly") {
        // labels = Object.keys(this.memberData.weekly_enrollment.this_week);
        labels = [...new Set([...labels, ...Object.keys(this.memberData.weekly_termed.this_week || {}), ...Object.keys(this.memberData.weekly_withdrawn.this_week || this.memberData.weekly_enrollment.this_week || {})])];
        enrollData = Object.values(this.memberData.weekly_enrollment.this_week);
        termedData = Object.values((this.memberData.weekly_termed && this.memberData.weekly_termed.this_week) || {});
        withdrawnData = Object.values((this.memberData.weekly_withdrawn && this.memberData.weekly_withdrawn.this_week) || {});
      }
      // else if (this.selectedFilter === "Monthly") {
      //   labels = [...new Set([...labels, ...Object.keys(this.memberData.monthly_termed|| {}), ...Object.keys(this.memberData.monthly_withdrawn || this.memberData.monthly_enrollment || {})])];
      //   enrollData = Object.values(this.memberData.monthly_enrollment || {})
      //   termedData = Object.values(this.memberData.monthly_termed || {})
      //   withdrawnData = Object.values(this.memberData.monthly_withdrawn || {})

      // }
      this.series = [
        { name: "Active", data: enrollData },
        { name: "Termed", data: termedData },
        { name: "Withdrawn", data: withdrawnData },
      ];
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: { categories: labels },
      };
    },
    getRistrictDownlineFlag() {
      let path = "v2/rep-restriction-downline";
      let loader = this.$loading.show();
      Api.post(path)
        .then((res) => {
          this.isDownlineHasAccess = res.data.has_access;
        })
        .catch((err) => {
          console.error("Error: ", err.response.data.message);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getEnrollableData(agentId = null) {
      const currentYear = new Date().getFullYear(); 
      let path = `v2/enrollprime-member-status?year=${currentYear}&last_days=30`;
      if (agentId) {
        path += `&agent_id=${agentId}`;
      }
      let loader = this.$loading.show();
      Api.get(path)
        .then((res) => {
          this.memberData = res.data.data;
          this.termedList = extractNameCount(this.memberData.termed_eligb_act)
          this.withdrawnList = extractNameCount(this.memberData.withdrawn_eligb_act)
          this.topReasons = this.mergeAndSortArrays(this.termedList,this.withdrawnList, (this.memberData.total_termed+this.memberData.total_withdraw));
          // this.selectedFilter = "Last 30 Days"; 
          this.updateChart()
        })
        .catch((err) => {
          console.error("Error: ", err.response.data.message);
        })
        .finally(() => {
          loader.hide();
        });
    },
    routeToLink(url) {
      let app = this;
      app.$router.push(`${url}`);
    },
    mergeAndSortArrays(array1, array2,reasonTotal) {
      // Append a percentage column to each array element
      const combinedArray = array1.concat(array2).map(item => ({
        ...item,
        percentage: calculatePercentage(item.total, reasonTotal)
      }));
      return combinedArray.sort((a, b) => b.total - a.total).slice(0, 5);
    },
  },
  watch: {
    selectedLocation(newVal) {
      this.getEnrollableData(newVal?.value || null);
    },
  },
};
</script>
<style src="@/assets/css/repdashboard.css"></style>
<style scoped>
.toggle-eye-icon {
  /* float:right; */
  margin-left: 2% !important;
}

.manage-btn button img {
  max-height: 1.25rem;
  padding-right: 0.35rem;
  vertical-align: middle;
}

/* .apps-btn button {
  background: transparent linear-gradient(103deg, #8360c3, #2ebf91) 0 0
    no-repeat padding-box;
}*/
</style>

